import * as React from "react";
import { styled } from "@mui/material";
import {
  MobileView,
  SingleViewPerLayoutBreakPoint,
} from "../../../../util/aKaunGeneralUtil";
import { StartNewCaseCard } from "./startNewCaseCard";
import { RestoreLastCase } from "./restoreLastCase";

//region [[ Styles ]]

const StartOverContentView = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  [theme.breakpoints.up(SingleViewPerLayoutBreakPoint)]: {
    minHeight: "auto",
  },
  "& > *": {
    margin: "20px",
    [theme.breakpoints.down(MobileView)]: {
      margin: 0,
    },
  },
  [theme.breakpoints.down(MobileView)]: {
    minHeight: "calc(100vh - 298px)",
  },
  [theme.breakpoints.down(SingleViewPerLayoutBreakPoint)]: {
    height: "stretch",
    flexWrap: "wrap",
    "& > *:not(:last-child)": {
      marginBottom: "20px",
    },
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface StartOverContentProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const StartOverContent = ({ ...props }: StartOverContentProps) => {
  return (
    <StartOverContentView>
      <StartNewCaseCard />
      <RestoreLastCase />
    </StartOverContentView>
  );
};
